/** Confirmação do endereço de e-mail (SPEC-IDN-014).
 *
 * A confirmação é `POST`, e não `GET`, mesmo sendo o alvo de um link: antivírus
 * de e-mail e pré-visualizador de caixa de entrada abrem os links antes da
 * pessoa. Com `GET`, um robô consumiria o token e o primeiro clique de verdade
 * receberia "link inválido".
 */

import { http } from "@/lib/http";
import type { components } from "@/lib/api-types";

export type EmailConfirmado = components["schemas"]["EmailConfirmadoResponse"];

export async function confirmarEmail(token: string): Promise<EmailConfirmado> {
  return http.post<EmailConfirmado>(`/auth/verify-email/${encodeURIComponent(token)}`);
}

/** Autenticada: reenvio anônimo por e-mail seria um oráculo de contas. */
export async function reenviarVerificacao(): Promise<void> {
  await http.post<{ detail: string }>("/auth/verify-email/resend");
}
